export class Storage {
    #namespace;
    constructor(namespace = "platform.auth") {
        this.#namespace = namespace;
    }
    #getNamespacedKey(key) {
        return `${this.#namespace}.${key}`;
    }
    get(type) {
        return sessionStorage.getItem(this.#getNamespacedKey(type));
    }
    set(type, value) {
        sessionStorage.setItem(this.#getNamespacedKey(type), value);
    }
    remove(type) {
        sessionStorage.removeItem(this.#getNamespacedKey(type));
    }
}
